import React from 'react'
import MenuCardsComponent from '../../components/menu-cards'

const MenuCardsPage = () => (
  <MenuCardsComponent />
);

export default MenuCardsPage;
